export const environment = {
  production: false,
  apiUrl: 'https://zg-dev.gnsgsw.com/backend/public/api',
  baseHref: '/remittance/'
};
